import {
  createApi,
  fetchBaseQuery,
  type BaseQueryFn,
  type FetchArgs,
  type FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import type { RootState } from '@/store';
import { logout } from '../slices/authSlice';

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  prepareHeaders: (headers, { getState, endpoint }) => {
    if (endpoint === 'getSession') {
      return headers;
    }

    const sessionToken = (getState() as RootState).auth.accessGameToken;
    if (sessionToken) {
      headers.set('authorization', `Bearer ${sessionToken}`);
    }

    return headers;
  },
});

/** Time to let the user see the failed state before leaving for the session error page. */
const SESSION_ERROR_REDIRECT_DELAY_MS = 2000;

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  const result = await baseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401 && api.endpoint !== 'getSession') {
    api.dispatch(logout());
    setTimeout(() => {
      if (window.location.pathname === '/session-error') return;
      window.location.href = '/session-error';
    }, SESSION_ERROR_REDIRECT_DELAY_MS);
  }
  return result;
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  tagTypes: ['Games', 'Bets'],
  endpoints: () => ({}),
});

export default apiSlice;
